import { render } from "./PersonaEmpr.vue?vue&type=template&id=3305d9a8&scoped=true"
import script from "./PersonaEmpr.vue?vue&type=script&lang=js"
export * from "./PersonaEmpr.vue?vue&type=script&lang=js"

import "@/assets/css/tablaHover.css?vue&type=style&index=0&id=3305d9a8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3305d9a8"]])

export default __exports__